import React from 'react'
import { Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'
import * as PropTypes from 'prop-types'
import { EyeOutlined, PlusOutlined } from '@ant-design/icons'

const CreateNewItemExtraButtons = ({ disabled, handleSubmit, hideView }) => {
  const { t } = useTranslation()

  return (
    <Space wrap>
      {hideView ? null : (
        <Button data-testid="create-and-view" onClick={() => handleSubmit('view')} disabled={disabled} icon={<EyeOutlined />}>
          {t('app.createAndView')}
        </Button>
      )}
      <Button data-testid="create-and-new" onClick={() => handleSubmit('new')} disabled={disabled} icon={<PlusOutlined />}>
        {t('app.createAndNew')}
      </Button>
    </Space>
  )
}

CreateNewItemExtraButtons.propTypes = {
  disabled: PropTypes.bool,
  hideView: PropTypes.bool,
  formName: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired
}

export default CreateNewItemExtraButtons
